/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react';
import { useMousePositionAsTrigger } from 'react-laag';
import Button from '../../../components/button';
import FormSelect from '../../../components/dropdown/formSelect';
import AnimationWrapper from '../../../components/animation/animationWrapper';
import PopoverModalComponent from '../../../components/modal/popoverModal';
import Search from '../../../components/search/search';
import Table from '../../../components/table';
import Heading from '../../../components/typography';
import InitialValuesForm from '../../../constants/initialValues';
import {
  ImportBlock,
  PageHeader,
  ResetFilterWrapper,
} from '../../../constants/style/common.styled';
import { VestingTemplatesHeader } from '../../../constants/table-headers/vestingTemplatesHeader';
import {
  VestingTemplateService,
  type Wealthlane_AwardService_Dtos_VestingTemplate_VestingTemplateForListDto,
} from '../../../services/wealthlane-award-services';
import { type ModalStatusType, type TableParamsType } from '../../../types/common';
import { SettingRoleButton } from '../system-roles/systemRoleStyled';
import VestingTemplatePopoverContent from './vestingTemplatePopoverContent';
import {
  useAdvanceBoolean,
  useBoolean,
  useGetTablePreferences,
  useGetVestingLoadingType,
  useGetVestingTemplateList,
  useGetVestingTypeOptions,
  usePostFileImport,
  usePostTablePreferences,
  useWealthlaneAwardApi,
} from '../../../hooks';
import ToastComponent from '../../../components/toast';
import AlertPopup from '../../../components/alert-popup';
import { toast } from 'react-toastify';
import { useQueryClient } from 'react-query';
import VestingModal from './vestingModal';
import { useNavigate } from 'react-router-dom';
import NewVestingModal from './newVestingModal';
import { PlainTextWrapper } from '../system-roles/roles.styled';
import { InputField } from '../../participants/participant.styled';
import { isEmpty } from 'lodash';
import ParticipantImportModal from '../../participants/participantImportModal';
import { handleOpenFile } from '../../../utils/global';
import Spinners from '../../../components/spinner';
// import useDynamicTable from '../../../packages/table-builder/hooks/useDynamicTable';
// import DynamicTable from '../../../packages/table-builder';
// import { withDynamicTableContext } from '../../../packages/table-builder/HOC/withDynamicTableContext';
// import useTableSchemaLoader from '../../../packages/table-builder/hooks/useTableSchemaLoader';
import {
  DynamicTable,
  withDynamicTableContext,
  useDynamicTable,
  useTableSchemaLoader,
} from '@wealthlane/table-builder';
import { axiosInstance } from '../../../services/apiInterceptor';
const initialValues = {
  data: InitialValuesForm.vestingTemplate,
  id: '',
};

const VestingTemplates = (): JSX.Element => {
  const [vestingType, setVestingType] = useState<string>('');
  const [searchQuery, setSearchQuery] = useState('');
  const [popoverData, setPopoverData] =
    useState<Wealthlane_AwardService_Dtos_VestingTemplate_VestingTemplateForListDto>({});
  const [modalLoading, setModalLoading] = useState(false);
  const [copyModalLoading, setCopyModalLoading] = useState(false);
  // const [tableInfo, setTableInfo] = useState<TableParamsType>(InitialValuesForm.tableParams);
  const { tableInfo, setTableInfo, registerPermissionHandler } = useDynamicTable();

  useEffect(() => {
    setTableInfo(InitialValuesForm.tableParams);
  }, []);

  useEffect(() => {
    registerPermissionHandler(() => (data: any, event: any) => {
      // console.log('Triggered handleShow with ID:', id);
      // console.log('popover info', popoverInfo);
      if (data) {
        setPopoverData(data);
      }
      if (event) {
        handleMouseEvent(event);
      }
    });
  }, [registerPermissionHandler]);

  const [headerList, setHeaderList] = useState<string[]>([]);
  const [modalStatus, setModalStatus] = useState<ModalStatusType>('Add');
  const [initialData, setInitialData] = useState(initialValues);
  const [importLoading, setImportLoading] = useState(false);
  const { value: isModalOpen, setFalse: closeModal, setTrue: openModal } = useBoolean(false);
  const {
    value: isConfirmOpen,
    setFalse: closeConfirmModal,
    setTrue: openConfirmModal,
    customValue,
    setCustomValue,
  } = useAdvanceBoolean<string>(false);
  const { handleRequest, error: exception } = useWealthlaneAwardApi();
  const { data: vestingTypeOptions, isLoading: isVestingTypeOptionsLoading } =
    useGetVestingTypeOptions(handleRequest);
  const { data: loadingTypeOptions, isLoading: isLoadingTypeOptions } =
    useGetVestingLoadingType(handleRequest);
  const { data, status } = useGetVestingTemplateList(
    handleRequest,
    tableInfo
    // vestingType != '' ? [vestingType] : []
  );
  window?.sessionStorage.setItem('ToPreviewData', '');

  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const [rowData, setRowData] = useState();

  const { schemaData, isTableSchemaLoading } = useTableSchemaLoader({
    identifier: 'VESTING_TEMPLATE_TABLE',
    baseUrl: process.env.REACT_APP_WEALTHLANE_API_ENDPOINT,
  });

  const { data: tablePreferences } = useGetTablePreferences(handleRequest, 'Vesting Template');

  useEffect(() => {
    tablePreferences != null && setHeaderList([...tablePreferences]);
  }, [tablePreferences]);

  const { mutate: postTablePreference, isLoading: tablePrefLoading } =
    usePostTablePreferences(handleRequest);

  const handleSavePreference = (value: string[]): void => {
    const prefPayload = {
      tableName: 'Vesting Template',
      preferences: value,
    };
    postTablePreference(prefPayload);
  };

  const tableActions = [
    {
      id: 'view',
      action: 'View',
      onClick: (id: string, rowData: any) => {
        setModalStatus('View');
        getVestingTemplateViewData(id);
        setRowData(rowData);
        openModal();
      },
    },
    {
      id: 'edit',
      action: 'Edit',
      as: 'Edit',
      onClick: (id: string) => {
        setModalStatus('Edit');
        getVestingTemplateByIdForUpdateData(id);
      },
    },
    {
      id: 'copy',
      action: 'Copy',
      as: 'Edit',
      onClick: (id: string) => {
        setModalStatus('Edit');
        copyVestingTemplateById(id);
      },
    },
    {
      id: 'preview',
      action: 'Preview',
      // as: 'Edit',
      onClick: (id: string, rowData: any) => {
        navigate('/settings/organization-settings/vesting-templates/preview', {
          state: {
            id: id,
            data: rowData,
            vestingTypeOptions: vestingTypeOptions,
            loadingTypeOptions: loadingTypeOptions,
          },
        });
      },
    },
    {
      id: 'delete',
      // action: <div className='delete-label'>Delete</div>,
      action: <div className='delete-label'>Delete</div>,
      as: 'Delete',
      onClick: (id: string) => {
        setModalStatus('Delete');
        openConfirmModal();
        setCustomValue(id);

        // deleteVestingTemplateById(id);
      },
    },
  ];

  const getVestingTemplateViewData = (id: string): void => {
    setModalLoading(true);
    handleRequest(VestingTemplateService.getApiAwardApiAppVestingTemplateVestingTemplateForView(id))
      .then((data: any) => {
        if (data != null) {
          setInitialData({ id, data });
          setModalLoading(false);
        }
      })
      .catch(() => {})
      .finally(() => {
        setModalLoading(false);
      });
  };

  const getVestingTemplateByIdForUpdateData = (id: string): void => {
    setModalLoading(true);
    handleRequest(VestingTemplateService.getApiAwardApiAppVestingTemplateVestingTemplate(id))
      .then((data: any) => {
        if (data != null) {
          openModal();
          setInitialData({ id, data });
          setModalLoading(false);
        }
        if (data === null || data === undefined) {
          closeModal();
        }
      })
      .catch(() => {})
      .finally(() => {
        setModalLoading(false);
      });
  };
  const copyVestingTemplateById = (id: string): void => {
    setCopyModalLoading(true);
    handleRequest(VestingTemplateService.postApiAwardApiAppVestingTemplateCopyVestingTemplate(id))
      .then((data: any) => {
        if (data != null && data?.success) {
          toast.success(<ToastComponent label={'Success'} message={'Vesting template copied.'} />);
          void queryClient.invalidateQueries('getVestingTemplateList');
          setCopyModalLoading(false);
        }
        if (data === null || data === undefined || !data?.success) {
          closeModal();
          setCopyModalLoading(false);
        }
      })
      .catch(() => {})
      .finally(() => {
        setCopyModalLoading(false);
        closeModal();
      });
  };
  const onPrimaryClick = (values: Record<string, any>): void => {
    deleteVestingTemplateById(customValue);
  };

  const deleteVestingTemplateById = (id: string): void => {
    setModalLoading(true);
    handleRequest(VestingTemplateService.deleteApiAwardApiAppVestingTemplateVestingTemplate(id))
      .then((data: any) => {
        if (data != null) {
          toast.success(<ToastComponent label={'Success'} message={'Vesting template deleted.'} />);
          void queryClient.invalidateQueries('getVestingTemplateList');
          setModalLoading(false);
          closeConfirmModal();
        }
      })
      .catch(() => {
        setModalLoading(false);
        closeConfirmModal();
      })
      .finally(() => {
        setModalLoading(false);
        closeConfirmModal();
      });
  };

  const {
    hasMousePosition, // did we get a mouse-position from the event-handler
    resetMousePosition, // reset the mouse-position to `null`, essentially closing the menu
    handleMouseEvent, // event-handler we will use below
    trigger, // information regarding positioning we can provide to `useLayer`
  } = useMousePositionAsTrigger();

  useEffect(() => {
    if (exception != null) {
      closeModal();
    }
  }, [exception]);

  const handleShow = (data: any, e: any): void => {
    setPopoverData(data);
    handleMouseEvent(e);
  };
  // const [importedData, setImportedData] = useState<any>();
  // const [eventBusId, setEventBusId] = useState<string>('');
  // const [formStatus, setFormStatus] = useState<ModalStatusType>('Create');
  // const [importCounter, setImportCounter] = useState(1);
  // const [importStatus, setImportStatus] = useState<any | null>();
  // const [importLoader, setImportLoader] = useState<boolean>(false);
  // const [parsedValue, setParsedValue] = useState<any>();
  // const [uploadTitle, setUploadTitle] = useState<string>('');
  // const [counter, setCounter] = useState(1);
  // const [verifiedLoader, setVerifiedLoader] = useState<boolean>(false);

  // const {
  //   value: isBulkModalOpen,
  //   setFalse: closeBulkModal,
  //   setTrue: openBulkModal,
  // } = useBoolean(false);

  // const { mutate, isLoading: ImportLoader } = usePostFileImport(
  //   handleRequest,
  //   setEventBusId,
  //   'VestingTemplate',
  //   setImportStatus,
  //   setImportCounter
  // );

  // function fileImport(event: any): void {
  //   setImportedData('');
  //   setFormStatus('Create');
  //   setImportStatus(null);
  //   if (!isEmpty(event.target.files)) {
  //     const payload = {
  //       File: event.target.files[0],
  //     };

  //     setImportLoader(true);

  //     mutate(payload);
  //     event.target.value = null;
  //     openBulkModal();
  //   }
  //   setEventBusId('');
  //   setParsedValue({});
  //   setUploadTitle('');
  // }

  // const onVerified = (): void => {
  //   setVerifiedLoader(true);
  //   const handleAPI = VestingTemplateService.postApiAwardApiAppVestingTemplateImportExcel(
  //     importedData?.id
  //   );
  //   (importedData as boolean) &&
  //     handleRequest(handleAPI)
  //       .then((data: any) => {
  //         if (data !== null) {
  //           setImportCounter(1);
  //           setUploadTitle('Adding all vesting template records');
  //           data?.id && setEventBusId(data.id);
  //           setImportStatus(data);
  //         }
  //       })
  //       .catch((error: any) => {
  //         console.log('error', error);
  //       });
  // };
  const importExcel = (event: any): void => {
    if (!isEmpty(event.target.files)) {
      setImportLoading(true);

      const payload = {
        File: event.target.files[0],
      };

      // const handleAPI =
      //   VestingTemplateService.postApiAwardApiAppVestingTemplateImportBulkVestingTemplateExcel(
      //     payload
      //   );

      handleRequest(
        VestingTemplateService.postApiAwardApiAppVestingTemplateImportBulkVestingTemplateExcel(
          payload
        )
      )
        .then((data: any) => {
          if (data) {
            toast.success(
              <ToastComponent label='Success' message='Vesting Template import job submitted.' />
            );
            queryClient.invalidateQueries('getVestingTemplateList');
            setImportLoading(false);
          }
        })
        .catch((error: any) => {
          console.log('error', error);
          setImportLoading(false);
        })
        .finally(() => {
          setImportLoading(false);
        });

      event.target.value = null;
    }
  };

  const downloadTemplate = (): void => {
    handleRequest(
      VestingTemplateService.postApiAwardApiAppVestingTemplateDownloadVestingTemplateSample()
    )
      .then((data: any) => {
        if (data != null) {
          handleOpenFile('Vesting Template.xlsx', data.content);
        }
      })
      .catch((error: any) => {
        console.log('error', error);
      });
  };
  const TemplateDatas = [
    {
      title: 'Download Template',
      download: downloadTemplate,
    },
    {
      title: 'Import Bulk XLS',
      import: importExcel,
    },
  ];

  const renderRightToolbarButton = () => {
    return (
      <Button
        as='Create'
        variant={'primary'}
        title={'Add Template'}
        id='vestingTemplatesAddTemplateButton'
        onClick={() => {
          setInitialData(initialValues);
          setModalStatus('Add');
          openModal();
        }}
        icon='add_circle'
      />
    );
  };

  const tableHeaderList = VestingTemplatesHeader({
    actions: schemaData?.columns,
    tableActions,
    hasMousePosition,
    resetMousePosition,
  })
    .filter((item) => item.isSubHeader)
    .map((item) => {
      // console.log('item', item);

      return {
        label: item.Header,
        value: item.accessor,
      };
    });

  const vetsingTemplateHeader = (): any[] => {
    return VestingTemplatesHeader({
      actions: schemaData?.columns,
      tableActions,
      hasMousePosition,
      resetMousePosition,
    }).filter((item) => item.isSubHeader === false || headerList.includes(item.accessor));
  };

  const schema = React.useMemo(
    () => ({
      columns: vetsingTemplateHeader(),
      options: schemaData?.options as any,
    }),
    [schemaData]
  );
  if (isTableSchemaLoading) return <Spinners containerClassName='h-screen' />;

  return (
    <div id='vestingTemplatesPageContainer'>
      <PageHeader data-page='vestingTemplates' id='vestingTemplatesPageHeader'>
        <Heading variant='h3' title='Vesting Templates' id='vestingTemplatesPageTitle' />
        <Heading
          variant='body-s'
          title='Current list of default and custom vesting templates.'
          id='vestingTemplatesPageDescription'
        />
      </PageHeader>

      <DynamicTable
        schema={schema}
        data={data?.items ?? []}
        totalCounts={data?.totalCount ?? 10}
        loading={status}
        templateDatas={TemplateDatas}
        components={{
          renderRightToolbarButton,
        }}
        tableColumnList={tableHeaderList}
        selectedColumnList={headerList}
        tablePreferenceLoading={tablePrefLoading}
        handleColumnSave={handleSavePreference}
        id='vestingTemplatesTable'
      />

      <PopoverModalComponent
        children={
          <VestingTemplatePopoverContent data={popoverData} id='vestingTemplatePopoverContent' />
        }
        hasMousePosition={hasMousePosition}
        trigger={trigger}
        popoverClassName='pop-overs'
        resetMousePosition={resetMousePosition}
        id='vestingTemplatePopoverModal'
      />
      {isConfirmOpen && (
        <AlertPopup
          isShow={isConfirmOpen}
          closeModal={closeConfirmModal}
          modalStatus={modalStatus}
          title={'this Vesting Template'}
          handleSubmit={onPrimaryClick}
          // setRemark={setRemark}
          // remark={remark}
          loading={modalLoading}
          id='vestingTemplatesDeleteAlert'
        />
      )}

      <AnimationWrapper id='vestingTemplatesAnimationWrapper'>
        {isModalOpen && (
          <NewVestingModal
            isModalOpen={isModalOpen}
            closeModal={closeModal}
            modalStatus={modalStatus}
            modalLoading={modalLoading}
            initialData={initialData}
            vestingTypeOptions={vestingTypeOptions}
            loadingTypeOptions={loadingTypeOptions}
            setModalStatus={setModalStatus}
            rowData={rowData}
            id='vestingTemplatesModal'
          />
        )}
      </AnimationWrapper>
    </div>
  );
};

export default withDynamicTableContext(VestingTemplates, false, axiosInstance);
